import React from "react";
import "./CreateLicense.css";

const CreateLicense = ({
    industry,
    streetAddress,
    companyName,
    city,
    state,
    zip,
    type,
    addIndustry,
    addStreetAddress,
    addCity,
    addState,
    getZip,
    index,
    addBusinessType,
    addCompanyName,
    deleteRow,
    validationErrors = {},
    clearValidationError,
}) => {
    const err = (field) => validationErrors[`${field}_${index}`];
    const clearErr = (field) => clearValidationError?.(`${field}_${index}`);

    const handleIndustryChange = (e) => { addIndustry(index, e.target.value); clearErr("industry"); };
    const handleNameChange = (e) => { addCompanyName(index, e.target.value); clearErr("company"); };
    const handleStreetAddressChange = (e) => { addStreetAddress(index, e.target.value); clearErr("address"); };
    const handleCityChange = (e) => { addCity(index, e.target.value); clearErr("city"); };
    const handleStateChange = (e) => { addState(index, e.target.value); clearErr("state"); };
    const handleZipChange = (e) => { getZip(index, e.target.value); clearErr("zip"); };
    const handleTypeChange = (e) => { addBusinessType(index, e.target.value); clearErr("businessType"); };

    return (
        <div className="Operator-CreateLicense">
            <div className="single-operator-container">
                <div className="form-row">
                    <div className="reg-field">
                        <label className="reg-required">Company Name</label>
                        <input
                            type="text"
                            value={companyName}
                            aria-required="true"
                            onChange={handleNameChange}
                            className={`registration-input${err("company") ? " input-error" : ""}`}
                            placeholder="Legal business name"
                        />
                        {err("company") && <span className="field-error">{err("company")}</span>}
                    </div>
                </div>
                <div className="form-row">
                    <div className="reg-field">
                        <label className="reg-required">License Type</label>
                        <select
                            value={type}
                            aria-required="true"
                            onChange={handleTypeChange}
                            className={`registration-input-1${err("businessType") ? " input-error" : ""} ${!type ? "reg-select-placeholder" : "reg-select-filled"}`}
                        >
                            <option value="">Select type</option>
                            <option value="wholesaler">Wholesaler</option>
                            <option value="cultivator">Cultivator</option>
                            <option value="retailer">Retailer</option>
                            <option value="manufacturer">Manufacturer / Processor</option>
                        </select>
                        {err("businessType") && <span className="field-error">{err("businessType")}</span>}
                    </div>
                    <div className="reg-field">
                        <label className="reg-required">Industry</label>
                        <select
                            value={industry}
                            aria-required="true"
                            onChange={handleIndustryChange}
                            className={`registration-input-1${err("industry") ? " input-error" : ""} ${!industry ? "reg-select-placeholder" : "reg-select-filled"}`}
                        >
                            <option value="">Select industry</option>
                            <option value="Rec / Adult Use">Rec / Adult Use</option>
                            <option value="Medical">Medical</option>
                            <option value="Hemp">Hemp</option>
                        </select>
                        {err("industry") && <span className="field-error">{err("industry")}</span>}
                    </div>
                </div>
                <div className="reg-field">
                    <label className="reg-required">Street Address</label>
                    <input
                        type="text"
                        value={streetAddress}
                        aria-required="true"
                        onChange={handleStreetAddressChange}
                        className={`registration-input${err("address") ? " input-error" : ""}`}
                        placeholder="123 Main St, Suite 100"
                    />
                    {err("address") && <span className="field-error">{err("address")}</span>}
                </div>
                <div className="flex-container">
                    <div className="reg-field">
                        <label className="reg-required">City</label>
                        <input
                            type="text"
                            value={city}
                            aria-required="true"
                            onChange={handleCityChange}
                            className={`registration-input-1${err("city") ? " input-error" : ""}`}
                            placeholder="City"
                        />
                        {err("city") && <span className="field-error">{err("city")}</span>}
                    </div>
                    <div className="reg-field">
                        <label className="reg-required">State</label>
                        <select
                            value={state}
                            aria-required="true"
                            onChange={handleStateChange}
                            className={`registration-input-1${err("state") ? " input-error" : ""} ${!state ? "reg-select-placeholder" : "reg-select-filled"}`}
                        >
                            <option value="">State</option>
                            {[
                                "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA",
                                "HI","ID","IL","IN","IA","KS","KY","LA","ME","MD",
                                "MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ",
                                "NM","NY","NC","ND","OH","OK","OR","PA","RI","SC",
                                "SD","TN","TX","UT","VT","VA","WA","WV","WI","WY",
                            ].map((s) => (
                                <option key={s} value={s}>{s}</option>
                            ))}
                        </select>
                        {err("state") && <span className="field-error">{err("state")}</span>}
                    </div>
                    <div className="reg-field">
                        <label className="reg-required">Zip Code</label>
                        <input
                            type="text"
                            value={zip}
                            aria-required="true"
                            onChange={handleZipChange}
                            className={`registration-input-1${err("zip") ? " input-error" : ""}`}
                            placeholder="00000"
                        />
                        {err("zip") && <span className="field-error">{err("zip")}</span>}
                    </div>
                </div>
                {deleteRow && (
                    <p className="reg-remove-license" onClick={() => deleteRow(index)}>
                        Remove license
                    </p>
                )}
            </div>
        </div>
    );
};

export default CreateLicense;
